import React, * as react from "react"
import { Link } from "react-router-dom"
import { Loading } from "./Loading"
import "./Helpers"
import "./VPLib/css/DialogUI.css"
import cn from "classnames"
import {PageView} from "../components/Tracking"
import linkifyHtml from "linkifyjs/html"

export default class Dashboard extends react.Component {  
	constructor(props) {
		super(props)
		const ProductName = props.ProductName
		const FullProductPath = props.FullProductPath
		const datasetDetails = props.datasetDetails
		const FieldArray = props.FieldArray
		const DetailFields = props.DetailFields
		const TitleViewField = props.TitleViewField
		const FullSummary = props.FullSummary
		const appURL = props.appURL
		this.state = {
			ViewObject: {},
			datasetDetails: datasetDetails,
			FieldArray: FieldArray,
			DetailFields: DetailFields,
			TitleViewField: TitleViewField,
			datasetID: props.datasetID,
			VPDatasetID: "",
			ProductName: ProductName,
			FullProductPath: FullProductPath,
			loading: true,
			selectedSheetID: props.selectedSheetID,
			FullSummary: FullSummary,
			appURL: appURL
		}
	}

	fetchData(appURL, datasetID, sheetData){
		
		let FeaturedSheets = []
		let NormalSheets = []
		let sheetNames = {}
		let VPDatasetID = ""
		var sortable = []
		for (var dataset in sheetData){
			sheetNames = JSON.parse(sheetData[dataset].SheetName)
			VPDatasetID = sheetData[dataset].ID[0]
		}
		for (var sheet in sheetNames){
			sortable.push([sheet, sheetNames[sheet]])
		}

		sortable.sort(function(a, b) {
			return a[1].screenshot[0] - b[1].screenshot[0]
		})
		
		var index = 0
		for (var temp in sheetNames){
			let sheet = sortable[index][0]
			var sheetType = sheetNames[sheet].status.toString()
			var sheetName = sheetNames[sheet].Name.toString()
			if (sheetType === "featured"){
				FeaturedSheets.push(sheetNames[sheet])
			}
			else if ((sheetType === "normal" || sheetType === "") && sheetName !== "Summary"){
				NormalSheets.push(sheetNames[sheet])
			}
			index++
		}

		/*Object.values(sheetNames).map(function (value) {
			console.log(value)
			if (value.status[0] === "featured"){
				FeaturedSheets.push(value)
			}
			else if ((value.status[0] === "normal" || value.status[0] === "") && value.Name[0] !== "Summary"){
				NormalSheets.push(value)
			}

		})*/
		this.setState({
			ViewObject: sheetNames,
			FeaturedSheets: FeaturedSheets,
			NormalSheets: NormalSheets,
			VPDatasetID: VPDatasetID,
			loading: false
		})
	}
	
	componentDidMount(){
		this.fetchData(this.state.appURL, this.state.datasetID, this.state.datasetDetails)
		PageView()
	}

	render() {
		const datasetID = this.state.datasetID
		const ProductName = this.state.ProductName
		const FullProductPath = this.state.FullProductPath
		const FieldArray = this.state.FieldArray
		const DetailFields = this.state.DetailFields
		const TitleViewField = this.state.TitleViewField
		const appURL = this.state.appURL
		const FullSummary = this.state.FullSummary
		const VPDatasetID = this.state.VPDatasetID
		return (
			<div>
				{this.state.loading === true
					? <Loading />
					:<div className="FillWindow Report">
						<div className="SummaryReport">
							<div className="LargeDashboardTile" title="Summary Report">
								<div className="TextBlock" dangerouslySetInnerHTML={{__html: linkifyHtml(FullSummary)}}>
						
								</div>
							</div>
						</div>
						<div className="Sheets">
							{			
								//Object.values(this.state.ViewObject).map(function (value) {
								this.state.FeaturedSheets.map(function(value, index) {
									let TileClass = "MediumDashboardTile"
									if (index === 0){
										TileClass = "LargeDashboardTile"
									}
									let detail1 = {}
									let detail2 = {}
									if (value.detailviews[0] !== ""){
										detail1 = JSON.parse(value.detailviews[0])
									}
									if (value.detailviewsuser[0] !== ""){
										detail2 = Object.values(JSON.parse(value.detailviewsuser[0]))
									}
									let DetailViewsArray = detail2
									if (typeof(detail1) === "object"){
										if (Object.keys(detail1).length > 0){
											if (detail1.hasOwnProperty("UseDefault")){
												if (detail1.UseDefault === 0){
													DetailViewsArray = detail1.DetailFields
												}
											}
										}
									}
									let iconString = ""

									if (value.hasOwnProperty("BrowserType")) {
										iconString = cn("vp-icon-32 WebIcon " + value.BrowserType[0], "FeaturedIcon")
									}
									else {
										iconString = cn("vp-icon-32 WebIcon " + value.Type[0], "FeaturedIcon")
									}
									
									let htmlToInsert = "<div class='" + iconString + "'></div>" + value.otherdata[0]
									return (
										<div className={TileClass} title={value.Name[0]} id={value.ID[0]} key={value.ID[0]}>
											<Link to={{pathname: "/"+ ProductName + "/" + value.Type[0] + "/" + datasetID + "/" + value.ID[0], state:  {VPDatasetID: VPDatasetID, appURL: appURL, ViewNote: value.Note[0], DetailViews: DetailViewsArray, FieldArray: FieldArray, DetailFields: DetailFields, TitleViewField: TitleViewField}}}>
												<div className="DashboardFill">
													<center>{value.Name[0]}</center>
													<div className="TextBlock" dangerouslySetInnerHTML={{__html: htmlToInsert}}></div>
												</div>
											</Link>
										</div>
									)
							
								})
							}
							{
								this.state.NormalSheets.map(function(value){
									let detail1 = {}
									let detail2 = {}
									if (value.detailviews[0] !== ""){
										detail1 = JSON.parse(value.detailviews[0])
									}
									if (value.detailviewsuser[0] !== ""){
										detail2 = Object.values(JSON.parse(value.detailviewsuser[0]))
									}
									let DetailViewsArray = detail2
									if (typeof(detail1) === "object"){
										if (Object.keys(detail1).length > 0){
											if (detail1.hasOwnProperty("UseDefault")){
												if (detail1.UseDefault === 0){
													DetailViewsArray = detail1.DetailFields
												}
											}
										}
									}
									let iconString = ""
									if (value.hasOwnProperty("BrowserType")) {
										iconString = cn("vp-icon-32 WebIcon " + value.BrowserType[0])
									}
									else {
										iconString = cn("vp-icon-32 WebIcon " + value.Type[0])
									}
									return (
										<div className="SmallDashboardTile" title={value.Name[0]} id={value.ID[0]} key={value.ID[0]}>
											<Link to={{pathname: "/"+ ProductName + "/" + value.Type[0] + "/" + datasetID + "/" + value.ID[0], state:  {VPDatasetID: VPDatasetID, appURL: appURL, ViewNote: value.Note[0], DetailViews: DetailViewsArray, FieldArray: FieldArray, DetailFields: DetailFields, TitleViewField: TitleViewField}}}>
												<div className="DashboardFill">
													<div className={iconString}></div>
													<div className="SheetDescriptionShort">{value.Name[0]}</div>
												</div>
											</Link>
										</div>
									)
									/*else if( value.status[0] === "hidden"){
							return ""

						}
						else {
							let iconString = "";
							if (value.hasOwnProperty('BrowserType')) {
								iconString = cn("vp-icon-32 WebIcon " + value.BrowserType[0])
							}
							else {
								iconString = cn("vp-icon-32 WebIcon " + value.Type[0])
							}
							return (
								<div className="SmallDashboardTile" title={value.Name[0]} id={value.ID[0]} key={value.ID[0]}>
									<Link to={{pathname: '/' + value.Type[0] + '/' + datasetID + '/' + value.ID[0], state:  {ViewNote: value.Note[0], DetailViews: value.detailviews[0]}}}>
									<div className="DashboardFill">
										<div className={iconString}></div>
										<div className="SheetDescriptionShort">{value.Name[0]}</div>
									</div>
									</Link>
								</div>
							)

						}*/
								})
							}
						</div>
					</div>
				}
			</div>
		)
	}
}